import React from "react";
import Button from "../../Button";
import FormPolicy from "../../forms/FormPolicy";
import styles from "./DownloadScreensModal.module.scss";
import { useFormik } from "formik";
import * as yup from "yup";

const validationSchema = yup.object({
  email: yup.string().email().required(),
  fullName: yup.string().required(),
});

const DownloadScreenForm = ({ submitHandler }) => {
  const formik = useFormik({
    initialValues: {
      email: "",
      fullName: "",
    },
    validateOnChange: false,
    onSubmit: (values) => {
      submitHandler(values);
      formik.resetForm();
    },
    validationSchema,
  });

  return (
    <>
      <h3 className={styles.title}>Download all screens</h3>

      <form className={styles.form} onSubmit={formik.handleSubmit}>
        <div className={styles.form_item}>
          <label className={styles.form_label}>Full Name</label>
          <input
            type="text"
            name="fullName"
            className={`${styles.form_input} ${
              formik.touched.fullName && formik.errors.fullName && styles.error
            }`}
            placeholder="Full Name"
            value={formik.values.fullName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </div>

        <div className={styles.form_item}>
          <label className={styles.form_label}>Email address</label>
          <input
            type="email"
            name="email"
            className={`${styles.form_input} ${
              formik.touched.email && formik.errors.email && styles.error
            }`}
            placeholder="Email address"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </div>

        <Button
          title="Download"
          fullWidth
          type="submit"
          className={styles.form_button}
        />
      </form>

      <FormPolicy />
    </>
  );
};

export default DownloadScreenForm;
